import React from "react";

const Visuel = ({ image }) => {
    return (
        <div className="flex_visuel">
            <img src={image.src} alt={image.alt} title={image.title} />
        </div>
    )
}
export default Visuel;